var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4433_16824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4433_16824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4433_16824)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2517 0H4.74831C2.12589 0 0 2.12589 0 4.74831V27.2517C0 29.8741 2.12589 32 4.74831 32H27.2517C29.8741 32 32 29.8741 32 27.2517V4.74831C32 2.12589 29.8741 0 27.2517 0Z",
    fill: "url(#paint0_radial_4433_16824)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.6159C3.50182 18.7264 9.25482 21.4112 15.7665 21.4112C22.2783 21.4112 28.5565 18.4763 32 14.0448V4.74831C32 2.12611 29.8739 0 27.2517 0H4.74831C2.12611 0 0 2.12611 0 4.74831V14.6201V14.6159Z",
    fill: "#D1FFEA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4433_16824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4625 0.53772H0.538086V31.4622H31.4625V0.53772Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4433_16824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9322 29.6862C12.7946 29.6862 12.6612 29.6529 12.5361 29.5778C12.2109 29.3902 12.0609 28.9942 12.1818 28.6357L15.4209 19.1266H6.04523C5.73257 19.1266 5.45326 18.9431 5.32402 18.6597C5.19479 18.3762 5.24482 18.0427 5.44909 17.8092L18.4725 2.98899C18.6268 2.8139 18.8477 2.71802 19.0687 2.71802C19.2063 2.71802 19.3397 2.75137 19.4647 2.82641C19.7899 3.01401 19.94 3.41004 19.8191 3.76856L16.5799 13.2777H25.9598C26.2724 13.2777 26.5517 13.4611 26.681 13.7446C26.8102 14.0281 26.7602 14.3616 26.5559 14.595L13.5325 29.4194C13.3782 29.5945 13.1573 29.6904 12.9363 29.6904L12.9322 29.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0687 3.51012L15.471 14.0656H25.9556L12.9321 28.89L16.5299 18.3345H6.04522L19.0687 3.51012ZM19.0687 1.92596C18.6268 1.92596 18.189 2.11356 17.8764 2.46374L4.85294 17.2881C4.44022 17.755 4.34434 18.4221 4.59864 18.9848C4.85711 19.5518 5.4199 19.9145 6.04106 19.9145H14.312L11.4272 28.3772C11.1854 29.0943 11.4772 29.8822 12.1317 30.2574C12.3819 30.3991 12.6528 30.47 12.9238 30.47C13.3657 30.47 13.8034 30.2824 14.1161 29.9322L27.1187 15.137C27.3772 14.8535 27.5398 14.4783 27.5398 14.0656C27.5398 13.1902 26.831 12.4815 25.9556 12.4815H17.6805L20.5653 4.01872C20.8071 3.30168 20.5153 2.51377 19.8608 2.13858C19.6106 1.99683 19.3396 1.92596 19.0687 1.92596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9321 29.3736C12.8487 29.3736 12.7695 29.3527 12.6903 29.3111C12.4943 29.1985 12.4026 28.9567 12.4777 28.7399L15.8586 18.8181H6.04514C5.85755 18.8181 5.68662 18.7097 5.60742 18.5346C5.52821 18.3595 5.56156 18.1636 5.68246 18.0218L18.7101 3.19329C18.806 3.0849 18.9352 3.0307 19.0728 3.0307C19.1561 3.0307 19.2353 3.05154 19.3146 3.09323C19.5105 3.20579 19.6022 3.44758 19.5272 3.66436L16.1462 13.5862H25.9639C26.1514 13.5862 26.3224 13.6946 26.4016 13.8697C26.4808 14.0448 26.4474 14.2407 26.3265 14.3824L13.3031 29.2068C13.2072 29.3152 13.078 29.3694 12.9404 29.3694L12.9321 29.3736Z",
    fill: "#FF8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0688 3.5101L15.4711 14.0656H25.9557L12.9323 28.89L16.53 18.3345H6.04537L19.0688 3.5101ZM19.0688 2.55127C18.802 2.55127 18.5352 2.66383 18.3476 2.87644L5.32416 17.7008C5.07403 17.9843 5.01566 18.3845 5.16991 18.7305C5.32416 19.0724 5.666 19.2933 6.04537 19.2933H15.1918L12.0277 28.5815C11.8817 29.0151 12.061 29.4903 12.457 29.7196C12.6071 29.8071 12.7739 29.8488 12.9365 29.8488C13.2033 29.8488 13.4701 29.7363 13.6577 29.5236L26.6644 14.7201C26.8229 14.5492 26.9229 14.3199 26.9229 14.0656C26.9229 13.5362 26.4935 13.1068 25.9641 13.1068H16.8135L19.9776 3.8186C20.1235 3.38504 19.9443 2.90979 19.5482 2.6805C19.3982 2.59296 19.2314 2.55127 19.0688 2.55127Z",
    fill: "#FF8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9595 13.6654H15.4707L19.0684 3.10986L6.04492 17.9343H16.5295L12.9318 28.4897L25.9595 13.6654Z",
    fill: "url(#paint1_radial_4433_16824)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4433_16824",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8254 -4.83169) scale(35.3434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D4D08C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6BC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#1CC277"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4433_16824",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4592 4.16458) scale(25.8676 25.8676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_16824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBadge);
export default __webpack_public_path__ + "static/media/light-badge.b3a899b5526edc6a20e9c03e337437af.svg";
export { ForwardRef as ReactComponent };